/* @flow */

export default {
  root: {
    width: 30,
    height: 30,
  },
};
